import {ChangeDetectionStrategy, Component, Input} from "@angular/core";

@Component({
    selector: 'checklist-accordion',
    templateUrl: './checklist-accordion.template.html',
    styleUrls: ['./checklist-accordion.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ChecklistAccordionComponent {

	@Input() visible: boolean = true;
	@Input() title: string;
}
